<app-popups-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-popups-filters>

<div class="table-container">
    <table mat-table matSort [dataSource]="popups" multiTemplateDataRows matSortDisableClear matSortDirection="asc">
        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Titolo </th>
            <td mat-cell *matCellDef="let element"> {{ element.title }} </td>
        </ng-container>

        <ng-container matColumnDef="content">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Contenuto </th>
            <td mat-cell *matCellDef="let element"> {{ element.content }} </td>
        </ng-container>

        <ng-container matColumnDef="start_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Data inizio </th>
            <td mat-cell *matCellDef="let element"> {{ element.start_date | date:'dd/MM/yyyy'}} </td>
        </ng-container>

        <ng-container matColumnDef="end_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Data fine </th>
            <td mat-cell *matCellDef="let element"> {{ element.end_date | date:'dd/MM/yyyy' }} </td>
        </ng-container>


        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="add-icon-container">
              <button mat-mini-fab *ngIf="canAdd" matTooltip="Nuovo popup"
                (click)="$event.stopPropagation(); addPopup()" color="primary">
                <mat-icon>add</mat-icon>
              </button>
            </th>
            <td mat-cell *matCellDef="let row" class="modify-icon-container">
              <ng-container>
                <button mat-icon-button (click)="$event.stopPropagation(); editPopup(row)">
                  <mat-icon matTooltip="Modifica">create</mat-icon>
                </button>
              </ng-container>
      
             
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editPopup(row)"></tr>
    </table>

  <mat-paginator     [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSizeOptions[0]"
  [length]="total | async">
  </mat-paginator>  

</div>